module.exports = __webpack_public_path__ + "img/l4.02326043.webp";